// Simple Google Maps connector
// Generates URLs for static maps using Google Maps Static API

export const getStaticMapUrl = (address, apiKey = '') => {
  const encoded = encodeURIComponent(address);
  // If no API key is provided, return a generic embed map link
  if (!apiKey) {
    return `https://www.google.com/maps?q=${encoded}&output=embed`;
  }
  return `https://maps.googleapis.com/maps/api/staticmap?center=${encoded}&zoom=14&size=400x300&key=${apiKey}`;
};

